import React, { ReactElement } from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations } from './configuration';
import { Button, Grid, Typography } from '@material-ui/core';
import { SchemeTypes } from '../../../../config';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import FixedEstablishmentsDataTable from './components/datatable';
interface IProps {
  mode: 'VIEW' | 'EDIT';
  scheme_type?: SchemeTypes;
  is_agent?: boolean;
  isExcluded: boolean;
  vatGroup: boolean;
}

export default function FixedEstablishment(props: IProps): ReactElement {
  const mode = props.mode;
  const isExcluded = props.isExcluded;
  const vatGroup = props.vatGroup;
  // console.log('Render FixedEstablishment');
  const dispatch = useDispatch();
  const openModal = (modal_id: number, params = {}) => {
    dispatch(
      ModalActions.openModalAction({
        modalID: modal_id,
        params: params,
      })
    );
  };

  return (
    <div>
      <Grid container>
        <Grid item sm={6} xs={12}>
          <Typography variant="h5">
            <TranslatedText textMap={Translations.header} />
          </Typography>
        </Grid>
        <Grid item sm={6} xs={12} style={{ textAlign: 'right' }}>
          <Button
            type="button"
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => openModal(ModalIDs.MODAL_FIXED_ESTABLISHMENT)}
            disabled={mode === 'VIEW' || isExcluded || vatGroup}
          >
            <TranslatedText textMap={Translations.modal_header} />
          </Button>
        </Grid>
      </Grid>
      <p>
        <TranslatedText textMap={Translations.subtitle} />
      </p>
      <FixedEstablishmentsDataTable mode={props.mode} />
    </div>
  );
}
